import api from '@pray/shared/utils/api';

export const updateLocaleConfig = async ({ localeId, elevenlabsConfig, artistId }) => {
  if (!localeId) throw Error('Locale ID is required');
  if (!elevenlabsConfig) throw Error('ElevenLabs config is required');

  const params = {
    elevenlabs_config: {
      model_id: elevenlabsConfig.model_id,
      stability: elevenlabsConfig.stability,
      similarity_boost: elevenlabsConfig.similarity_boost,
      // Only multilingual v2 uses these; the modal leaves them out for other models
      ...(elevenlabsConfig.style !== undefined && { style: elevenlabsConfig.style }),
      ...(elevenlabsConfig.use_speaker_boost !== undefined && {
        use_speaker_boost: elevenlabsConfig.use_speaker_boost,
      }),
    },
  };

  if (artistId) {
    params.artist_id = artistId;
  }

  const url = `/web/studio/locales/${localeId}`;
  const response = await api.executePutRequest(url, params);
  return response.data;
};
